import _ from "lodash"

import Model from "../../../../model/model"
import { ID, Idea, Location } from "../../../../model/types"
import Hub from "../../../../hub"

export default class NavigationHistory {
  open_location: Location | null
  navigation_history: ID[]
  navigation_history_pointer: number | null

  model: Model
  hub: Hub

  constructor() {
    this.navigation_history = []
    this.navigation_history_pointer = null
  }

  attachToHub(hub: Hub): void {
    this.hub = hub
    this.hub.on(
      "navigation-history:set-open-location",
      ({ location, selectionPos }) => {
        this.set_open_location(location, {
          selection_pos: selectionPos,
        })
      }
    )
  }

  get_open_location(): Location | null {
    return this.open_location
  }

  get_open_idea(): Idea | null {
    if (!this.open_location) return null
    const id = this.model.getIdeaIdAt(this.open_location)
    if (!id) return null
    return this.model.getIdea(id)
  }

  set_open_location(
    location: Location | null,
    {
      save_to_history,
      selection_pos,
    }: { save_to_history?: boolean; selection_pos?: number } = {}
  ): void {
    if (save_to_history === undefined) save_to_history = true
    if (selection_pos === undefined) selection_pos = 0

    if (
      !_.isEqual(this.open_location, location) &&
      save_to_history &&
      location !== null
    ) {
      const id = this.model.getIdeaIdAt(location)
      if (id) {
        if (this.navigation_history_pointer != null) {
          this.navigation_history = this.navigation_history.slice(
            0,
            this.navigation_history_pointer + 1
          )
          this.navigation_history_pointer = null
        }
        this.navigation_history.push(id)
      }
    }
    this.open_location = location
    this.hub.emit("navigation-history:open-location-set", {
      location: location,
      selectionPos: selection_pos,
    })
  }

  // TODO if the idea has been deleted, skip over it
  navigate_back(): void {
    if (this.navigation_history_pointer == null)
      this.navigation_history_pointer = this.navigation_history.length - 1
    else if (this.navigation_history_pointer == 0) return
    else if (this.navigation_history_pointer >= 0)
      this.navigation_history_pointer--
    if (
      this.get_open_idea()?.id ===
      this.navigation_history[this.navigation_history_pointer]
    )
      this.navigation_history_pointer--
    const id = this.navigation_history[this.navigation_history_pointer]
    if (id) {
      const idea = this.model.getIdea(id)
      if (idea)
        this.set_open_location(idea.location, { save_to_history: false })
    }
  }

  // TODO if the idea has been deleted, skip over it
  navigate_forward(): void {
    if (this.navigation_history_pointer == null) return
    if (this.navigation_history_pointer >= this.navigation_history.length - 1)
      return
    this.navigation_history_pointer++
    const id = this.navigation_history[this.navigation_history_pointer]
    if (id) {
      const idea = this.model.getIdea(id)
      if (idea)
        this.set_open_location(idea.location, { save_to_history: false })
    }
  }
}
